const columns = () => ([
  {
    title: 'Preview',
    dataIndex: 'imageUri',
    key: 'imageUri',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Order',
    dataIndex: 'index',
    key: 'index',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
  },
]);

export default columns;
